export function formatDate(dateString: string) {
  const date = new Date(dateString);

  const day = date.getUTCDate();
  const month = date.toLocaleString("en-US", { month: "long" });
  const year = date.getUTCFullYear();

  // Adding suffix to the day
  const daySuffix = (day: number) => {
    if (day > 3 && day < 21) return "th"; // handles 11th to 13th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  return `${day}${daySuffix(day)} ${month}, ${year}`;
}

export function formatSameDayDelivery(deadlineISO: string) {
  const d = new Date(deadlineISO);
  if (Number.isNaN(d.getTime())) return "";

  const dateLabel = d.toLocaleDateString(undefined, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const timeLabel = d.toLocaleTimeString(undefined, {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return `${dateLabel} • by ${timeLabel}`;
}
